module.exports = __webpack_public_path__ + "static/media/ellipse-orange.623cce71.png";